<div class="container-fluid h-100 d-flex flex-column bg-light-custom">
    <div class="row bg-don-g justify-content-between p-3">
        <div class="col">
            <img src="./../../assets/img/logo_fdg_278_50.png"
                 height="60"
                 alt="Fondazione Don Gnocchi">
        </div>
        <div class="col text-right">
            <p class="text-don-g font-weight-bold">Assistenza alla mobilità outdoor dei pazienti</p>
        </div>
    </div>

    <div class="row d-flex flex-grow-1 align-items-center justify-content-center bg-don-g">
        <div class="card col-12 col-sm-8 col-md-6">
            <div class="card-body">
                <h4 class="card-title font-weight-bold">Accesso al sistema</h4>
                <h5 class="card-subtitle m-3 font-weight-bold">Consenso al tratamento dei dati</h5>
                <section style="height:50vh; overflow: auto;">
                    <div style="text-align: center;">
                        <h4>INFORMATIVA RELATIVA AL TRATTAMENTO DEI DATI PERSONALI DEI CLIENTI
                            AI SENSI DEL REGOLAMENTO (UE) 2016/679 (“GDPR”)</h4>
                    </div>
                    <table align="center"
                           border=0>
                        <tr>
                            <td><svg width="32px"
                                     xmlns="http://www.w3.org/2000/svg"
                                     viewBox="0 0 128 160"
                                     x="0px"
                                     y="0px">
                                    <title>most_search2BF</title>
                                    <g>
                                        <circle cx="64"
                                                cy="39"
                                                r="25" />
                                        <path d="M74,74H54a40,40,0,0,0-40,40H114A40,40,0,0,0,74,74Z" />
                                    </g>
                                </svg></td>
                            <td>
                                <h4>Titolare del trattamento</h4>
                                <p>EBWorld S.r.l. – Strada degli Olmi 16/4 6112 Pesaro (PU) – 0721 172 2210 - P.IVA 00841260417 info@ebw.it
                                    (“Società”)
                                </p>
                            </td>
                        </tr>
                    </table>
                    <br>
                    <table align="center"
                           border=0>
                        <tr>
                            <td><svg width="32px"
                                     xmlns="http://www.w3.org/2000/svg"
                                     xmlns:xlink="http://www.w3.org/1999/xlink"
                                     version="1.1"
                                     x="0px"
                                     y="0px"
                                     viewBox="0 0 60 75"
                                     style="enable-background:new 0 0 60 60;"
                                     xml:space="preserve">
                                    <path
                                          d="M22.25,10.66c-0.56,0-1,0.45-1,1v5.33c0,0.56,0.44,1,1,1h15.5c0.55,0,1-0.44,1-1v-5.33c0-0.55-0.45-1-1-1H22.25z" />
                                    <path d="M17.11,32.79c-2.07,0-3.82,1.45-4.27,3.39h8.54C20.93,34.23,19.19,32.79,17.11,32.79z" />
                                    <circle cx="17.11"
                                            cy="28.47"
                                            r="2.32" />
                                    <path
                                          d="M51.62,13.33H40.75v3.66c0,1.65-1.35,3-3,3h-15.5c-1.65,0-3-1.35-3-3v-3.66H8.37C6.51,13.33,5,14.84,5,16.7v29.25  c0,1.86,1.51,3.38,3.37,3.38h43.25c1.86,0,3.38-1.52,3.38-3.38V16.7C55,14.84,53.48,13.33,51.62,13.33z M14.09,31.54  c-0.8-0.78-1.3-1.87-1.3-3.08c0-2.38,1.94-4.32,4.32-4.32c2.38,0,4.32,1.94,4.32,4.32c0,1.21-0.5,2.3-1.3,3.08  c2,1.08,3.37,3.2,3.37,5.63c0,0.55-0.45,1-1,1H11.73c-0.56,0-1-0.45-1-1C10.73,34.74,12.09,32.63,14.09,31.54z M48.72,44.18H11.28  c-0.55,0-1-0.45-1-1c0-0.55,0.45-1,1-1h37.44c0.55,0,1,0.45,1,1C49.72,43.73,49.27,44.18,48.72,44.18z M48.72,38.17H30.97  c-0.56,0-1-0.45-1-1s0.44-1,1-1h17.75c0.55,0,1,0.45,1,1S49.27,38.17,48.72,38.17z M48.72,32.15H30.97c-0.56,0-1-0.44-1-1  c0-0.55,0.44-1,1-1h17.75c0.55,0,1,0.45,1,1C49.72,31.71,49.27,32.15,48.72,32.15z M48.72,26.14H30.97c-0.56,0-1-0.45-1-1  s0.44-1,1-1h17.75c0.55,0,1,0.45,1,1S49.27,26.14,48.72,26.14z" />
                                </svg></td>
                            <td>
                                <h4>Dati personali trattati</h4>
                                <p>Nome, Cognome, Codice fiscale, Cellulare, E-mail, Posizione GPS rilevata dalla App</p>
                            </td>
                        </tr>
                    </table>
                    <br>
                    <table align="center"
                           border=0>
                        <tr>
                            <td><svg width="32px"
                                     xmlns="http://www.w3.org/2000/svg"
                                     xmlns:xlink="http://www.w3.org/1999/xlink"
                                     version="1.1"
                                     x="0px"
                                     y="0px"
                                     viewBox="0 0 100 125"
                                     enable-background="new 0 0 100 100"
                                     xml:space="preserve">
                                    <g>
                                        <path
                                              d="M86.669,1.169L75.677,12.162l-0.188,0.757l0,0l-1.982,8.022l-0.859,3.475l-0.299-0.299l-21.069,21.07   C50.868,45.077,50.445,45,50,45c-2.762,0-5,2.238-5,5s2.238,5,5,5s5-2.238,5-5c0-0.445-0.077-0.869-0.186-1.279l7.398-7.399   l7.144-7.143l0,0l6.527-6.528l-0.298-0.297l12.253-3.031l10.992-10.992l-12.16-0.001L86.669,1.169z" />
                                        <path
                                              d="M50,35c1.34,0,2.633,0.193,3.87,0.524l7.689-7.69C58.103,26.027,54.172,25,50,25c-13.809,0-25,11.191-25,25   s11.191,25,25,25s25-11.191,25-25c0-4.172-1.027-8.102-2.834-11.56l-7.69,7.69C64.807,47.368,65,48.66,65,50   c0,8.271-6.729,15-15,15s-15-6.729-15-15C35,41.729,41.729,35,50,35z" />
                                        <path
                                              d="M89.039,29.177l-9.354,2.314C83.048,36.865,85,43.207,85,50c0,19.299-15.701,35-35,35S15,69.299,15,50   c0-19.299,15.701-35,35-35c6.794,0,13.137,1.952,18.511,5.315l2.312-9.354l0.187-0.756C64.737,6.887,57.591,5,50,5   C25.145,5,5,25.145,5,50s20.145,45,45,45s45-20.145,45-45c0-7.591-1.887-14.738-5.205-21.01L89.039,29.177z" />
                                    </g>
                                </svg></td>
                            <td>
                                <h4>Finalità del trattamento</h4>
                                <p>Finalità connesse alla sperimentazione delle funzionalità del progetto "Soluzione di assistenza alla mobilità
                                    outdoor dei
                                    pazienti". A
                                    seguito di Sua esplicita approvazione, i dati personali e, in particolare la posizione GPS rilevata tramite App
                                    installata
                                    sul suo
                                    smartphone, verranno elaborati e visualizzati su una postazione operatore. Lo scopo è di tracciare i suoi
                                    movimenti e le
                                    caratteristiche della sua mobilità sul territorio nazionale durante l'arco della giornata.</p>
                                <p>Adempiere ad obblighi previsti da regolamenti e dalla normativa nazionale e sovranazionale applicabile.</p>
                                <p>Se necessario, per accertare, esercitare o difendere i diritti del Titolare in sede giudiziaria.</p>
                            </td>
                        </tr>
                    </table>
                    <br>
                    <table align="center"
                           border=0>
                        <tr>
                            <td><svg width="26px"
                                     xmlns="http://www.w3.org/2000/svg"
                                     xmlns:xlink="http://www.w3.org/1999/xlink"
                                     viewBox="0 0 73 125"
                                     style="background-color:#ffffff00;"
                                     version="1.1"
                                     xml:space="preserve"
                                     x="0px"
                                     y="0px">
                                    <g>
                                        <g>
                                            <path d="M 48.3081 65.0758 C 48.3081 58.5865 43.0215 53.326 36.5 53.326 C 29.9773 53.326 24.6907 58.5865 24.6907 65.0758 C 24.6907 68.9652 26.5976 72.4037 29.5228 74.5417 L 29.5228 95 L 36.5 90.1522 L 43.4771 95 L 43.4771 74.5417 C 46.4018 72.4025 48.3081 68.9652 48.3081 65.0758 ZM 36.5 60.6766 C 38.9377 60.6766 40.921 62.6507 40.921 65.0758 C 40.921 67.5033 38.9377 69.4761 36.5 69.4761 C 34.0617 69.4761 32.0778 67.5033 32.0778 65.0758 C 32.0778 62.6507 34.0617 60.6766 36.5 60.6766 Z"
                                                  fill="#000000" />
                                            <g>
                                                <path d="M 64.3064 84.1451 L 56.9962 84.1451 C 54.9565 84.1451 53.3027 82.5001 53.3027 80.4698 C 53.3027 78.4395 54.9565 76.7945 56.9962 76.7945 L 60.6129 76.7945 L 60.6129 22.3531 L 50.5619 12.3506 L 12.3872 12.3506 L 12.3872 76.7945 L 16.3525 76.7945 C 18.3922 76.7945 20.046 78.4395 20.046 80.4698 C 20.046 82.5001 18.3922 84.1451 16.3525 84.1451 L 8.6936 84.1451 C 6.6538 84.1451 5 82.5001 5 80.4698 L 5 8.6753 C 5 6.6456 6.6538 5 8.6936 5 L 52.0919 5 C 53.0718 5 54.0108 5.387 54.704 6.0767 L 66.9185 18.2321 C 67.6111 18.9212 68 19.8562 68 20.8307 L 68 80.4698 C 68 82.5001 66.3462 84.1451 64.3064 84.1451 Z"
                                                      fill="#000000" />
                                            </g>
                                        </g>
                                    </g>
                                </svg></td>
                            <td>
                                <h4>Base giuridica del trattamento</h4>
                                <p>Consenso da lei espresso nell’Applicazione Mobile da lei installata ed utilizzata.</p>
                                <p>Necessità di assolvere gli obblighi di legge ai sensi dell’art. 6, lettera b), c) e f) del Regolamento europeo.</p>
                                <p>Interesse legittimo ai sensi dell'art. 6, lettera f) del Regolamento Europeo.</p>
                            </td>
                        </tr>
                    </table>
                    <br>
                    <table align="center"
                           border=0>
                        <tr>
                            <td><svg width="36px"
                                     xmlns="http://www.w3.org/2000/svg"
                                     viewBox="0 0 24 30"
                                     x="0px"
                                     y="0px">
                                    <title>Deadline</title>
                                    <g>
                                        <path
                                              d="M13,11v3a1,1,0,0,1-2,0V11a1,1,0,0,1,2,0Zm-.44,5.17a.76.76,0,0,0-.18-.09L12.2,16a1,1,0,0,0-.58.06,1,1,0,0,0-.33.21A1,1,0,0,0,11,17a1,1,0,0,0,.07.38,1.46,1.46,0,0,0,.22.33,1,1,0,0,0,1.42,0,1.15,1.15,0,0,0,.21-.33A1,1,0,0,0,13,17a1.05,1.05,0,0,0-.29-.71A1.58,1.58,0,0,0,12.56,16.17ZM20,14A8,8,0,1,1,6.31,8.38l-.72-.73A1,1,0,0,1,7,6.24l.9.9A7.94,7.94,0,0,1,11,6.07S11,6,11,6V4h-.5a1,1,0,0,1,0-2h3a1,1,0,0,1,0,2H13V6s0,0,0,.07A7.94,7.94,0,0,1,16.1,7.14l.9-.9a1,1,0,0,1,1.41,1.41l-.72.73A8,8,0,0,1,20,14Zm-2,0a6,6,0,1,0-6,6A6,6,0,0,0,18,14Z" />
                                    </g>
                                </svg></td>
                            <td>
                                <h4>Periodo di conservazione dei dati e luogo di conservazione</h4>
                                <p>I dati verranno conservati per la durata del progetto e comunque per un periodo non superiore a sei mesi dalla
                                    registrazione sul
                                    sistema. Qualora ne chiedesse la cancellazione immediata, comunque la società procederà alla rimozione immediata e
                                    permanente.</p>
                                <p>Il luogo di conservazione dei dati è situato su server Google Cloud Platform, che è responsabile di garantire la
                                    riservatezza e
                                    l’accesso sicuro a tali dati.</p>
                            </td>
                        </tr>
                    </table>
                    <br>
                    <table align="center"
                           border=0>
                        <tr>
                            <td><svg width="28px"
                                     xmlns="http://www.w3.org/2000/svg"
                                     xmlns:xlink="http://www.w3.org/1999/xlink"
                                     version="1.1"
                                     x="0px"
                                     y="0px"
                                     viewBox="0 0 16 20"
                                     style="enable-background:new 0 0 16 16;"
                                     xml:space="preserve">
                                    <g>
                                        <g>
                                            <path
                                                  d="M15,15H1c-0.551,0-1-0.448-1-1V8.5C0,8.224,0.224,8,0.5,8h3c0.189,0,0.362,0.107,0.447,0.276L4.809,10h6.382l0.861-1.724    C12.138,8.107,12.311,8,12.5,8h3C15.776,8,16,8.224,16,8.5V14C16,14.552,15.552,15,15,15z M15,14v0.5V14L15,14z M1,9v5h14V9    h-2.191l-0.861,1.724C11.862,10.893,11.689,11,11.5,11h-7c-0.189,0-0.362-0.107-0.447-0.276L3.191,9H1z" />
                                            <path
                                                  d="M15.5,9c-0.172,0-0.339-0.089-0.432-0.248L11.713,3H4.287L0.932,8.752C0.793,8.99,0.487,9.074,0.248,8.932    C0.01,8.793-0.071,8.486,0.068,8.248l3.5-6C3.658,2.094,3.822,2,4,2h8c0.178,0,0.342,0.094,0.432,0.248l3.5,6    c0.14,0.238,0.059,0.545-0.18,0.684C15.673,8.979,15.586,9,15.5,9z" />
                                        </g>
                                        <path d="M10.5,5h-5C5.224,5,5,4.776,5,4.5S5.224,4,5.5,4h5C10.776,4,11,4.224,11,4.5S10.776,5,10.5,5z" />
                                        <path d="M11.5,7h-7C4.224,7,4,6.776,4,6.5S4.224,6,4.5,6h7C11.776,6,12,6.224,12,6.5S11.776,7,11.5,7z" />
                                    </g>
                                </svg></td>
                            <td>
                                <h4>Obbligatorietà del conferimento dei dati</h4>
                                <p>Il conferimento dei dati è obbligatorio per la conclusione del contratto/incarico, pertanto il mancato, parziale o
                                    inesatto
                                    conferimento di tali Dati rende impossibile la conclusione dello stesso.</p>
                            </td>
                        </tr>
                    </table>
                    <br>
                    <table align="center"
                           border=0>
                        <tr>
                            <td><svg width="32px"
                                     xmlns="http://www.w3.org/2000/svg"
                                     xmlns:xlink="http://www.w3.org/1999/xlink"
                                     version="1.1"
                                     x="0px"
                                     y="0px"
                                     viewBox="0 0 120 150"
                                     style="enable-background:new 0 0 120 120;"
                                     xml:space="preserve">
                                    <g>
                                        <path
                                              d="M45.4,64c-1-1.1-1.9-2.3-2.6-3.6c-0.9,0.1-1.8,0.2-2.8,0.2c-3.7,0-7.2-1.1-10.1-2.9c-7.5,1.9-13,8.6-13,16.6v9.3h15   C32.2,74.8,37.6,67.3,45.4,64z" />
                                        <path
                                              d="M40,55.6c0.3,0,0.6,0,0.9,0c-0.4-1.5-0.6-3-0.6-4.6c0-8,4.9-15,11.8-18c-2.6-4-7.1-6.6-12.2-6.6c-8.1,0-14.6,6.6-14.6,14.6   S31.9,55.6,40,55.6z" />
                                        <path
                                              d="M90.1,57.7c-3,1.8-6.4,2.9-10.1,2.9c-0.9,0-1.9-0.1-2.8-0.2c-0.7,1.3-1.6,2.5-2.6,3.6c7.7,3.3,13.2,10.9,13.5,19.7h15v-9.3   C103.1,66.3,97.6,59.6,90.1,57.7z" />
                                        <path
                                              d="M79.6,51c0,1.6-0.2,3.1-0.6,4.6c0.3,0,0.6,0,0.9,0c8.1,0,14.6-6.6,14.6-14.6S88.1,26.3,80,26.3c-5.1,0-9.6,2.6-12.2,6.6   C74.7,36,79.6,42.9,79.6,51z" />
                                        <path
                                              d="M83.1,84.4c0-8-5.5-14.8-13-16.6c-3,1.8-6.4,2.9-10.1,2.9c-3.7,0-7.2-1.1-10.1-2.9c-7.5,1.9-13,8.6-13,16.6v9.3h46.2V84.4z   " />
                                        <path
                                              d="M60,36.3c-8.1,0-14.6,6.6-14.6,14.6c0,8.1,6.6,14.6,14.6,14.6c8.1,0,14.6-6.6,14.6-14.6C74.6,42.9,68.1,36.3,60,36.3z" />
                                    </g>
                                </svg></td>
                            <td>
                                <h4>Destinatari dei dati e soggetti autorizzati al trattamento</h4>
                                <p>I dati potranno essere resi noti a dipendenti e collaboratori della Società, in qualità di Incaricati del
                                    trattamento, che
                                    operano nel
                                    rispetto delle istruzioni impartite dalla Società. I Suoi dati personali potranno inoltre essere trattati da
                                    soggetti
                                    terzi, di cui la
                                    Società si avvale ai fini delle finalità indicate. In ogni caso tali soggetti opereranno in qualità di Titolari
                                    del
                                    trattamento
                                    autonomi.</p>
                            </td>
                        </tr>
                    </table>
                    <br>
                    <table align="center"
                           border=0>
                        <tr>
                            <td><svg width="32px"
                                     xmlns="http://www.w3.org/2000/svg"
                                     xmlns:xlink="http://www.w3.org/1999/xlink"
                                     version="1.1"
                                     x="0px"
                                     y="0px"
                                     viewBox="0 0 100 125"
                                     enable-background="new 0 0 100 100"
                                     xml:space="preserve">
                                    <path
                                          d="M91.9,47.79c0-0.208-0.074-0.417-0.23-0.578L80.293,35.419c0.297-0.491,0.479-1.06,0.479-1.676  c0-1.796-1.457-3.251-3.252-3.251c-1.522,0-2.789,1.051-3.143,2.463c-0.287-0.068-1.418-0.451-2.049-0.664  c-1.225-0.413-2.529-0.853-3.221-1.069c-1.9-0.596-5.623-1.628-7.527-1.86c-0.648-0.08-1.629-0.12-2.913-0.12  c-1.179,0-2.493,0.033-3.737,0.078c1.176-1.227,1.905-2.88,1.905-4.713c0-3.775-3.06-6.835-6.834-6.836l0,0  c-3.775,0.001-6.835,3.061-6.835,6.836c0,1.833,0.731,3.486,1.906,4.713c-1.245-0.045-2.56-0.078-3.737-0.078  c-1.285,0-2.266,0.04-2.914,0.12c-1.903,0.232-5.627,1.264-7.527,1.86c-0.691,0.216-1.995,0.657-3.221,1.069  c-0.63,0.213-1.761,0.595-2.047,0.664c-0.354-1.413-1.622-2.463-3.144-2.463c-1.796,0-3.251,1.456-3.251,3.251  c0,0.615,0.181,1.185,0.478,1.675L8.33,47.211c-0.156,0.161-0.23,0.37-0.23,0.578H6.94c0,7.324,6.957,13.263,15.541,13.263  c8.583,0,15.54-5.938,15.54-13.263h-1.159c0-0.208-0.075-0.417-0.23-0.578L25.254,35.419c0.088-0.146,0.171-0.294,0.235-0.454  c0.068,0.021,0.138,0.041,0.221,0.041c0.519,0,1.834-0.438,3.781-1.105c0.717-0.247,1.395-0.478,1.821-0.604  c1.917-0.563,5.784-1.339,7.709-1.457c0.204-0.013,0.452-0.019,0.736-0.019c1.432,0,3.611,0.154,5.512,0.314v41.227h-2.562  c-2.278,0-4.124,1.847-4.124,4.125h-1.387c-1.309,0-2.37,1.06-2.37,2.369c0,1.311,1.061,2.371,2.37,2.371H50l0,0h12.805  c1.309,0,2.368-1.061,2.368-2.371c0-1.31-1.062-2.369-2.368-2.369h-1.388c0-2.278-1.849-4.125-4.125-4.125H54.73V32.136  c1.899-0.16,4.08-0.313,5.514-0.313c0.283,0,0.531,0.006,0.734,0.019c1.926,0.117,5.793,0.893,7.709,1.457  c0.426,0.125,1.104,0.357,1.819,0.604c1.947,0.667,3.265,1.105,3.781,1.105c0.084,0,0.153-0.019,0.223-0.041  c0.063,0.16,0.146,0.308,0.234,0.454L63.369,47.211c-0.156,0.161-0.23,0.37-0.23,0.578H61.98c0,7.324,6.955,13.263,15.539,13.263  s15.541-5.938,15.541-13.263L91.9,47.79L91.9,47.79z M34.876,47.79H10.085l10.822-11.217c0.468,0.261,0.999,0.422,1.573,0.422  c0.574,0,1.104-0.161,1.573-0.422L34.876,47.79z M65.125,47.79l10.822-11.217c0.469,0.261,0.998,0.422,1.572,0.422  c0.573,0,1.104-0.161,1.573-0.422l10.82,11.217H65.125z" />
                                </svg></td>
                            <td>
                                <h4>Modalità del trattamento – Diritti dell’interessato – Reclamo all’autorità di controllo</h4>
                                <p>Contattando la Società via e-mail, gli interessati possono chiedere al titolare l’accesso ai dati che li
                                    riguardano, la
                                    loro
                                    cancellazione, la rettifica dei dati inesatti, l’integrazione dei dati incompleti, la limitazione del trattamento
                                    nei casi
                                    previsti
                                    dall’art. 18 GDPR, nonché l’opposizione al trattamento nelle ipotesi di legittimo interesse del titolare. Il
                                    trattamento
                                    dei dati
                                    personali avverrà mediante strumenti manuali, informatici o telematici, idonei comunque a garantire la sicurezza e
                                    la
                                    riservatezza</p>
                                <p>Gli interessati, inoltre, nel caso in cui il trattamento sia basato sul consenso o sul contratto e sia effettuato
                                    con
                                    strumenti
                                    automatizzati hanno il diritto di ricevere in un formato strutturato, di uso comune e leggibile da dispositivo
                                    automatico
                                    i dati,
                                    nonché, se tecnicamente fattibile, di trasmetterli ad altro titolare senza impedimenti.</p>
                                <p>Gli interessati hanno il diritto di proporre reclamo all'Autorità di controllo competente nello Stato membro in cui
                                    risiedono
                                    abitualmente o lavorano o dello Stato in cui si è verificata la presunta violazione.
                                </p>
                            </td>
                        </tr>
                    </table>
                </section>
                <div class="card-footer d-flex justify-content-end"
                     *ngIf="!mobile;else mobileMessage">
                    <a class="card-link font-weight-bold"
                       (click)="onRejectPrivacy()">RIFIUTO</a>
                    <a class="card-link font-weight-bold"
                       (click)="onAcceptPrivacy()">ACCETTO</a>
                </div>
            </div>
        </div>
    </div>
</div>

<ng-template #mobileMessage>
    <div class="card-footer alert patient-alert-danger rounded-0">
        <p class="text-center">Sito disponibile solo da desktop</p>
    </div>
</ng-template>